import { useRecoilValue } from "recoil";
import { Box, Grid, Stack } from "@mui/joy";
import React, { useCallback, useEffect, useState } from "react";
import { patientAtom } from "recoil/patientAtom";
import {
  dashboardApi,
  DashboardType,
  DASHBOARD_DETAIL_ENDPOINT,
  DASHBOARD_DOMAIN,
} from "api/dashboardApi";
import { useQuery } from "@tanstack/react-query";
import ContentTemplate from "./ContentTemplate";
import PaymentModule from "components/sidebar/PaymentModule";
import { useTranslation } from "react-i18next";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import { userAtom } from "recoil/userAtom";
import { getExtraAutomaticThoughtKey } from "logic/logics";
import ThoughtMap from "components/thoughtmap/ThoughtMap";
import { isDev } from "config";

function Section({ content }: { content: React.ReactNode }) {
  return <Box sx={{ height: "100%" }}>{content}</Box>;
}

export default function MyThoughtMapContent() {
  const patientState = useRecoilValue(patientAtom);
  const userState = useRecoilValue(userAtom);
  const isPatient = userState?.accessToken && userState?.role === "patient";

  const queryFn = useCallback(
    () => dashboardApi.load(`${patientState?.patientId}`),
    [patientState]
  );
  const [dashboardData, setDashboardData] = useState<DashboardType>();
  useQuery([DASHBOARD_DOMAIN, DASHBOARD_DETAIL_ENDPOINT], queryFn, {
    enabled: !!patientState?.patientId,
    onSuccess: (data) => {
      setDashboardData(data.result);
      console.log(data.result?.concept);
    },
  });

  useEffect(() => {
    if (!patientState?.patientId) {
      setDashboardData({
        concept: {},
        history: {},
        selfCheckResult: {},
      });
    }
  }, [patientState]);

  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });
  const { isSubscribing, isNotStarted } = useSubscriptionStatus();

  const showPaymentModule = isPatient && !isSubscribing;
  return (
    <ContentTemplate>
      <Stack spacing={2}>
        {showPaymentModule && (
          <PaymentModule
            title={t_payment("스스로를 깊게 이해해보세요")}
            subtitle={t_payment(
              isNotStarted ? "7일 무료 체험" : "월별 결제, 언제든 취소 가능"
            )}
            size={"lg"}
          />
        )}
        {dashboardData && (
          <Stack spacing={2}>
            <Grid
              container
              spacing={2}
              alignItems="stretch"
              sx={{ flexGrow: 1, width: "100%" }}
            >
              <Grid xs={12} sx={{ p: 0 }}>
                <Section
                  content={
                    <ThoughtMap
                      data={{
                        ...dashboardData?.concept,
                        [getExtraAutomaticThoughtKey(dashboardData?.concept)]:
                          undefined,
                        // automaticThought1: undefined,
                      }}
                    />
                  }
                />
              </Grid>
            </Grid>
          </Stack>
        )}
      </Stack>
    </ContentTemplate>
  );
}
